import React from 'react';
import { withTheme } from 'styled-components';

import { Button } from '@e4/ui';
import ListItem from './ListItem';
import ItemContent from './ItemContent';

const ButtonItem = withTheme(({ onClick, theme, className, ...rest }) => (
  <ListItem className={className}>
    <Button onClick={onClick}>
      <ItemContent {...rest} iconSize="1.1rem" HSpacerProps={{ small: 1 }} />
    </Button>
  </ListItem>
));

export default ButtonItem;
